import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signIn } from "../api/auth";

function Signin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        try {
            const response = await signIn({ email, password });
            console.log("Sign in successful", response);
            
            if (response.authToken) {
                 const params = new URLSearchParams(window.location.search);
                 const redirectUrl = params.get('redirect');
                 
                 // Persist user data here too if this app needs it, 
                 // BUT crucial part is sending it back to the calling app or letting them fetch it.
                 // The calling app (Expense Tracker) expects 'user' in localStorage. 
                 // Since we are redirecting, we can't write to their localStorage directly.
                 // We pass the token. The Expense App currently relies on 'user' object in localStorage.
                 // OPTION: We should pass user data in URL or have Expense App fetch it using token.
                 // Given current setup, we pass token. Expense App might need to be smart enough to fetch user if missing.
                 
                 // However, for immediate fix matching current architecture:
                 if (redirectUrl) {
                     window.location.href = `${redirectUrl}?token=${response.authToken}`;
                 } else {
                     alert("Login Successful! (No redirect target)");
                 }
            }
        } catch (err: any) {
            console.error("Authentication failed", err);
            setError("Invalid credentials or server error");
        }
    };

    return (
        <div className="auth-container">
            <h2>Sign In</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit">Sign In</button>
            </form>
            <p style={{ textAlign: "center", marginTop: "1rem" }}>
                Don't have an account? <Link to="/signup">Sign Up</Link>
            </p>
        </div>
    );
}

export default Signin;